 
// components/common/GeoBlockedLayout.js
import React from 'react';
import Footer from './Footer';
import logo from "../../assets/images/hbcu_go/von-logo.png";

const GeoBlockedLayout = () => {
  return (
    <div
      style={{
        minHeight: '100vh',
        display: 'flex',
        flexDirection: 'column',
        backgroundColor: '#060117',
      }}
    >
      {/* Header */}
      <header
        style={{
          backgroundColor: '#040517',
          padding: '18px 24px',
          borderBottom: '1px solid rgba(255,255,255,0.08)',
        }}
      >
        <div
          style={{
            maxWidth: '1200px',
            margin: '0 auto',
            display: 'flex',
            alignItems: 'center',
          }}
        >
          <img
            src={logo}
            alt="HBCU GO"
            style={{
              height: '42px',
              width: 'auto',
              objectFit: 'contain',
            }}
          />
        </div>
      </header>

      {/* Main Content */}
      <main
        style={{
          flex: 1,
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          padding: '50px 24px',
        }}
      >
        <div
          style={{
            width: '100%',
            maxWidth: '600px',
            backgroundColor: '#0c0920',
            borderRadius: '20px',
            padding: '50px 40px',
            textAlign: 'center',
            border: '1px solid rgba(255,255,255,0.08)',
            boxShadow: '0 20px 60px rgba(0,0,0,0.45)',
          }}
        >
          {/* Warning Icon */}
          <div
            style={{
              width: '72px',
              height: '72px',
              margin: '0 auto 24px',
              borderRadius: '50%',
              backgroundColor: 'rgba(255,193,7,0.10)',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              fontSize: '34px',
            }}
          >
            🔒
          </div>

          {/* Heading */}
          <h1
            style={{
              margin: '0 0 16px',
              color: '#ffffff',
              fontSize: '32px',
              fontWeight: 600,
              lineHeight: 1.25,
              letterSpacing: '-0.02em',
            }}
          >
            Content Restricted
          </h1>

          {/* Main Message */}
          <p
            style={{
              margin: '0 auto 16px',
              maxWidth: '500px',
              color: '#c4c8d0',
              fontSize: '17px',
              lineHeight: 1.7,
            }}
          >
            This content is currently unavailable in your region due to
            restrictions.
          </p>

          {/* Support Message */}
          <p
            style={{
              margin: 0,
              color: '#858b98',
              fontSize: '14px',
              lineHeight: 1.6,
            }}
          >
           Please try again later or check back when this content becomes available in your region
          </p>
        </div>
      </main>

      {/* Footer */}
      <Footer />
    </div>
  );
};

export default GeoBlockedLayout;
 
